import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Shared Fit + Position picker for uploaded images across the Admin console.
// Props:
//   fit / position — current values (default "cover" / "center")
//   onChange(patch) — receives a partial object like { image_fit: "contain" }
//   testidPrefix — unique per editor instance
export default function ImageFitControls({ fit = "cover", position = "center", onChange, testidPrefix = "img" }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      <div>
        <Label className="label-caps text-muted-foreground">Image Fit</Label>
        <Select value={fit} onValueChange={(v) => onChange({ image_fit: v })}>
          <SelectTrigger className="mt-2 rounded-none" data-testid={`${testidPrefix}-fit`}><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="contain">Fit — show whole image (centered)</SelectItem>
            <SelectItem value="cover">Fill — crop to fill frame</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label className="label-caps text-muted-foreground">Image Position</Label>
        <Select value={position} onValueChange={(v) => onChange({ image_position: v })}>
          <SelectTrigger className="mt-2 rounded-none" data-testid={`${testidPrefix}-position`}><SelectValue /></SelectTrigger>
          <SelectContent className="rounded-none">
            <SelectItem value="center">Center</SelectItem>
            <SelectItem value="top">Top</SelectItem>
            <SelectItem value="bottom">Bottom</SelectItem>
            <SelectItem value="left">Left</SelectItem>
            <SelectItem value="right">Right</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
